import React from 'react';
import SubHeader from '../../components/Common/SubHeader/SubHeader';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import ProductContainer from '../../components/AllProducts/ProductContainer/ProductContainer';
import AllProductBanner from '../../components/AllProducts/AllProductBanner/AllProductBanner';


const AllProducts = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <AllProductBanner/>
            <ProductContainer/>
            <Footer/>
        </div>
    );
};

export default AllProducts;